import React from 'react';
import {FormattedMessage} from 'react-intl';
import classNames from 'classnames';
import Icon from '../Icon';
import messages from '../../../res/translations/messages';
import {generateCawiUrl} from '../../utils/urls';

const CawiButton = ({id, disabled}) => (
    <a className={classNames('btn btn-outline-primary', {disabled: disabled})} href={generateCawiUrl(id)}
        target="_blank" rel="noopener noreferrer">
        <Icon icon="view" /> <FormattedMessage {...messages.surveys.button.preview} />
    </a>
);

export default CawiButton;
